
































































# import settings from '@/settings'
import Menus from '@/components/menus'
import n from '@/utils/notifications'
import t from '@/utils/tools'
import q from '@/graphql/query'
import m from '@/graphql/mutation'

export default {
    name: 'company_elections'

    components: { Menus }

    data: ()->
        false: false
        true: true
        min: 0
        clearable: true
        errors: {}
        election: {
            uid: ''
            employees: 0
            done: false
            last_election: ""
            next_election: ""
        }
        picker_options: {firstDayOfWeek:1}

    computed:
        readonly: ()->
            return !t.has_access_right('elections_edit')

    methods:
        new_next_election: ()->
            # console.log @election.last_election
            if @election.last_election != null
                date_array = @election.last_election.split('-')
                @election.next_election = (parseInt(date_array[0])+4).toString()+'-'+date_array[1]+'-'+date_array[2]
            return

        get_errors: (fieldName)->
            ret = null
            if @errors[fieldName]?
                ret = @errors[fieldName][0]
            return ret

        get_election: ()->
            self = @
            q.run('get_election', [@$store.getters.current_company.uid])
            .then (resp)->
                if resp.body.errors? and resp.body.errors.length > 0
                    for e in resp.body.errors
                        n.gql_error("company_elections: get_election: then", e.message)
                else
                    # console.log "GET ELECTIONS : ", resp.body.data.election
                    if resp.body.data.election != null
                        self.election = resp.body.data.election
            .catch (resp)->
                n.catch_error(resp, "company_elections: get_election()")

        save: ()->
            # console.log "SAVE ELECTION", @election
            self = @
            @election.company_uid = @$store.getters.current_company.uid
            m.run('save_election', [@election])
            .then (resp)->
                if resp.body.data.election_form_mutation.form_ret == 'failed'
                    return n.access_denied()
                if resp.body.data.election_form_mutation.errors.length > 0
                    # console.log "ERRORS", resp.body.data.election_form_mutation.errors
                    self.errors = resp.body.data.election_form_mutation.errors.reduce(
                        (acc, el)->
                            acc[el.field] = el.messages
                            return acc
                    ,{})
                    n.form_error()
                else
                    self.errors = {}
                    self.get_election()
                    n.success()
            .catch (resp)->
                n.catch_error(resp, "company_elections: save()")
            
    beforeMount: ()->
        @get_election()
}
